import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import {
  AppsSharedModule,
  BaseAdministrationModule,
  BaseCustomerDepartmentModule,
  BaseDocumentsModule,
  BasePspBranchModule,
  BaseSharedModule,
} from 'base';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { BaseCustomerAdministrationMasterDataComponent } from './_components/master-data/base-customer-master-data.component';
import { BaseCustomerLocationComponent } from './_components/organisation-management/location/base-customer-location.component';
import { BaseCustomerLocationItemComponent } from './_components/organisation-management/location-item/base-customer-location-item.component';
import { BaseCustomerLocationDepartmentItemComponent } from './_components/organisation-management/location-department-item/base-customer-location-department-item.component';
import { BaseCustomerLocationTerminalComponent } from './_components/organisation-management/location-terminal/base-customer-location-terminal.component';
import { BaseCustomerLocationTimeRecordingComponent } from './_components/organisation-management/_modals/location-modal/time-recording-tab/location-time-recording/base-customer-location-time-recording.component';
import { BaseCustomerCreateEditLocationTerminalComponent } from './_components/organisation-management/_modals/location-modal/time-recording-tab/create-edit-location-terminal/base-customer-create-edit-location-terminal.component';
import { BaseCustomerEmployeeLeaseComponent } from './_components/organisation-management/_modals/location-modal/employee-lease-tab/employee-lease-form/base-customer-employee-lease.component';
import { BaseCustomerLocationFormComponent } from './_components/organisation-management/_modals/location-modal/master-data-tab/location-form/base-customer-location-form.component';
import { BaseCustomerLocationDocumentsListComponent } from './_components/organisation-management/_modals/location-modal/documents-tab/location-documents-list/base-customer-location-documents-list.component';
import { BaseCustomerLocationDocumentComponent } from './_components/organisation-management/_modals/location-modal/documents-tab/location-document/base-customer-location-document.component';
import { BaseCustomerDepartmentAddEditModalComponent } from './_components/organisation-management/_modals/department-modal/department-add-edit-modal/base-customer-department-add-edit-modal.component';
import { BaseCustomerDepartmentFavoritesComponent } from './_components/organisation-management/_modals/department-modal/favorites-tab/department-favorites/base-customer-department-favorites.component';
import { BaseCustomerQualificationListItemComponent } from './_components/organisation-management/_modals/department-modal/favorites-tab/qualification-list-item/base-customer-qualification-list-item.component';
import { BaseCustomerDepartmentMasterDataComponent } from './_components/organisation-management/_modals/department-modal/master-data-tab/department-master-data/base-customer-department-master-data.component';
import { BaseCustomerDepartmentOperationInformationComponent } from './_components/organisation-management/_modals/department-modal/assignment-information-tab/department-operation-information/base-customer-department-operation-information.component';
import { BaseCustomerDepartmentUserComponent } from './_components/organisation-management/_modals/department-modal/users-tab/department-user/base-customer-department-user.component';
import { BaseCustomerDepartmentUserItemComponent } from './_components/organisation-management/_modals/department-modal/users-tab/department-user-item/base-customer-department-user-item.component';
import { BaseCustomerContractTermsComponent } from './_components/organisation-management/_modals/location-modal/employee-lease-tab/contract-terms/base-customer-contract-terms.component';
import { BaseCustomerSurchargeItemComponent } from './_components/organisation-management/_modals/location-modal/employee-lease-tab/surcharge-item/base-customer-surcharge-item.component';
import { BaseCustomerLocationAddEditComponent } from './_components/organisation-management/_modals/location-modal/location-add-edit-modal/base-customer-location-add-edit.component';
import { BaseCustomerCategoryListItemComponent } from './_components/organisation-management/_modals/department-modal/favorites-tab/category-list-item/base-customer-category-list-item.component';
import { BaseCustomerFavoriteSectionComponent } from './_components/organisation-management/_modals/department-modal/favorites-tab/favorite-section/base-customer-favorite-section.component';

@NgModule({
  imports: [
    CommonModule,
    BaseAdministrationModule,
    BaseDocumentsModule,
    BaseSharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule,
    BaseCustomerDepartmentModule,
    BasePspBranchModule,
    AppsSharedModule,
    BaseCustomerSharedModule,
  ],
  declarations: [
    BaseCustomerAdministrationMasterDataComponent,
    BaseCustomerLocationComponent,
    BaseCustomerLocationItemComponent,
    BaseCustomerLocationAddEditComponent,
    BaseCustomerLocationDepartmentItemComponent,
    BaseCustomerLocationTerminalComponent,
    BaseCustomerLocationTimeRecordingComponent,
    BaseCustomerCreateEditLocationTerminalComponent,
    BaseCustomerEmployeeLeaseComponent,
    BaseCustomerLocationFormComponent,
    BaseCustomerLocationDocumentsListComponent,
    BaseCustomerLocationDocumentComponent,
    BaseCustomerDepartmentAddEditModalComponent,
    BaseCustomerDepartmentFavoritesComponent,
    BaseCustomerQualificationListItemComponent,
    BaseCustomerDepartmentMasterDataComponent,
    BaseCustomerDepartmentOperationInformationComponent,
    BaseCustomerDepartmentUserComponent,
    BaseCustomerDepartmentUserItemComponent,
    BaseCustomerContractTermsComponent,
    BaseCustomerSurchargeItemComponent,
    BaseCustomerCategoryListItemComponent,
    BaseCustomerFavoriteSectionComponent,
  ],
  exports: [BaseCustomerAdministrationMasterDataComponent, BaseCustomerLocationComponent],
  providers: [],
})
export class BaseCustomerAdministrationModule {}
